import cx from "classnames";
import { forwardRef } from "react";

import styles from "./styles.module.css";
import Box from "../Box";

type KeyboardHintProps = {
  keys: string;
  label?: string;
  className?: string;
};

const KeyboardHint = forwardRef<HTMLDivElement, KeyboardHintProps>(function KeyboardHint(
  { keys, label, className },
  ref
) {
  return (
    <Box ref={ref} align="center" className={cx(styles.keyboardHint, className)}>
      <Box align="center" justify="center" className={styles.key}>
        <span className={styles.keyText}>{keys}</span>
      </Box>
      {label && <span className={styles.label}>{label}</span>}
    </Box>
  );
});

KeyboardHint.displayName = "DS.KeyboardHint";

export default KeyboardHint;
